import { useTranslation } from "react-i18next";

const ChatListItem = ({
    chat,
    isActive,
    menuChatId,
    onSelect,
    onToggleMenu,
    onTogglePin,
    onRequestDelete,
}) => {
    const { t } = useTranslation();
    return (
        <button
            key={chat.id}
            type="button"
            onClick={() => onSelect(chat)}
            className={`w-full text-left rounded-[18px] px-4 py-3 transition border border-white/50
            ${
                isActive
                    ? "bg-white/75 shadow-[0_18px_44px_rgba(15,23,42,0.12)]"
                    : "bg-white/40 hover:bg-white/60 shadow-md"
            }`}
        >
            <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 min-w-0">
                    {chat.unread ? (
                        <span className="h-2 w-2 rounded-full bg-indigo-600" />
                    ) : null}
                    <div className="text-sm font-semibold text-slate-900 truncate">
                        {chat.title}
                    </div>
                </div>
                <div className="flex items-center gap-2 text-[10px] text-slate-500 whitespace-nowrap">
                    <div>{chat.updatedAt}</div>
                    <div className="relative">
                        <button
                            type="button"
                            className="h-6 w-6 rounded-full border border-white/60 bg-white/70 shadow-[0_10px_24px_rgba(15,23,42,0.08)] flex items-center justify-center text-slate-500"
                            onClick={(event) => {
                                event.stopPropagation();
                                onToggleMenu(chat.id);
                            }}
                            aria-label="Chat menu"
                        >
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="12" cy="5" r="2" fill="currentColor" />
                                <circle cx="12" cy="12" r="2" fill="currentColor" />
                                <circle cx="12" cy="19" r="2" fill="currentColor" />
                            </svg>
                        </button>
                        {menuChatId === chat.id && (
                            <div
                                className="absolute grid right-0 w-36 rounded-[14px] border border-white/70 bg-gradient-to-br from-white/90 via-[#F3EEFF] to-[#EDEBFF] shadow-[0_18px_50px_rgba(79,70,229,0.22)] overflow-hidden z-50"
                                onClick={(event) => event.stopPropagation()}
                            >
                                <button
                                    type="button"
                                    className="w-full text-left px-3 py-2 text-xs text-slate-700 hover:bg-white/70"
                                    onClick={() => onTogglePin(chat.id)}
                                >
                                    {chat.pinned ? t('aura list unpin') : t('aura list pin')}
                                </button>
                                <button
                                    type="button"
                                    className="w-full text-left px-3 py-2 text-xs text-rose-600 hover:bg-rose-50/80"
                                    onClick={() => onRequestDelete(chat.id)}
                                >
                                    {t('aura list delete')}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="text-[11px] text-slate-500 truncate mt-1">
                {chat.messages?.[chat.messages.length - 1]?.content}
            </div>
        </button>
    );
};

export default ChatListItem;
